import { ElementType, forwardRef } from 'react';
import { TypographyComponentProps } from '../../types';
import { Typography } from '../../Typography';

export type BodyProps = Omit<TypographyComponentProps, 'as'> & { size?: 'medium' | 'large'; as?: ElementType };

export const Body = forwardRef<HTMLElement, BodyProps>(({ size, as = 'p', ...props }, ref) => (
    <Typography ref={ref} as={as} {...props} textStyle={size === 'medium' ? 'bodyMedium' : 'bodyLarge'} />
));
